import React from 'react';
import { observer } from 'mobx-react';
import { CardLayout, Catcher, FieldInfoAdvanced, ShowDataBytes, cardLayoutOptions } from '../../';
import { IFieldLayout, IShowForm } from '../../../interfaces';
import { useCardInfo, useCardStatistics, useProfile } from '../../../hooks';
import { minutesRange, smsRange } from '../../../instruments';

export const CardInfoUsage: React.FC<IShowForm> = observer(() => {
    const layout: IFieldLayout = {
        labelCol: {
            flex: '0 1 200px',
        },
        valCol: {
            flex: '1 1 180px',
        },
    };
    const cardStatistics = useCardStatistics();
    const { currency } = useProfile();
    const { usageLimitByte } = useCardInfo();

    return (
        <Catcher>
            <CardLayout
                columnOption={cardLayoutOptions.cardInfo}
                idSpinners={['GET_CARD', 'GET_CARD_STATISTICS']}
                title={'Card Data Usage Current Month'}
            >
                <FieldInfoAdvanced title={'Data'} layout={layout}>
                    <ShowDataBytes bytes={cardStatistics?.byte} isHumanView />
                </FieldInfoAdvanced>
                <FieldInfoAdvanced title={'Voice'} layout={layout}>
                    {minutesRange(cardStatistics?.sec)}
                </FieldInfoAdvanced>
                <FieldInfoAdvanced title={'SMS'} layout={layout}>
                    {smsRange(cardStatistics?.sms)}
                </FieldInfoAdvanced>
                <FieldInfoAdvanced title={'Current Costs'} layout={layout}>
                    {(cardStatistics?.cost as number)?.toFixed(2) || 0} {currency}
                </FieldInfoAdvanced>
                <FieldInfoAdvanced title={'Card data limit per month'} layout={layout}>
                    <ShowDataBytes bytes={usageLimitByte} isHumanView noDataText={'Unlimited'} />
                </FieldInfoAdvanced>
            </CardLayout>
        </Catcher>
    );
});
